import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import { Link } from "react-router";
import ConfirmActions from "../../../Action/Actions/ConfirmActions";
import SignoutActions from "../../../Action/Actions/SignoutActions";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { UserSettingsInterface } from "../../../Entity/Entities/Settings/User/UserSettingsInterface";
import PersonFactory from "../../../Entity/Factories/PersonFactory";
import UserSettingsFactory from "../../../Entity/Factories/UserSettingsFactory";
import UserActions from "../../../Action/Actions/UserActions";
import Select from "../../Partials/Material/Select";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import ConfirmWillMount from "../../../Middleware/Middlewares/ConfirmWillMount";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";

class Confirm extends Component {

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_CONFIRM_CLEAR;
  protected passwordRegExp: RegExp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]{8,}$/;

  private types: {
    readonly standard: string,
    readonly confirm: string,
    readonly reset: string,
    expired: string
  } = {
    standard: "standard",
    confirm: "confirm",
    reset: "reset",
    expired: "expired"
  };

  public state = {
    email: "",
    id: null,
    type: this.types.standard,
    signinUserFirstName: this.props.confirm.user.firstName,
    signinUserLastName: this.props.confirm.user.lastName,
    signinUserAgencyId: this.props.confirm.user.agencyId,
    signinUserId: this.props.confirm.user.id,
    wrongPassword: false,
    tokenAlreadyUsed: false
  };

  protected middlewares: MiddlewareInterface[] = [
    ConfirmWillMount
  ];

  constructor(public props) {
    super(props);

    this.updatePassword = this.updatePassword.bind(this);
    this.updateConfirmPassword = this.updateConfirmPassword.bind(this);
    this.renderInitialConfirmPage = this.renderInitialConfirmPage.bind(this);
    this.renderEnterPasswordForm = this.renderEnterPasswordForm.bind(this);
    this.renderResetPasswordForm = this.renderResetPasswordForm.bind(this);
    this.renderSigninForm = this.renderSigninForm.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

 /**
  * This is the hotfix for react-router issue, that cause the problem of
  * infinite rerendering of component: routeParams(received for react-router Route) props
  * updates few times per sec
  * 
  * TODO: Should be fixed by installing the new version of react-router-dom
  * */
  shouldComponentUpdate(newProps, nextState) {
    if (this.state !== nextState) return true;
    const isPropsStringsSame = JSON.stringify(newProps) === JSON.stringify(this.props)
    if (
      isPropsStringsSame
      && newProps.routeParams !== this.props.routeParams
    ) {
      return false;
    }

    return !isPropsStringsSame;
  }

  protected updatePassword(e) {
    this.props.dispatch({
      type: Constants.PAGE_CONFIRM_ERRORS_CLEAR
    })

    if (!!e.target.value) {
      this.setState({
        wrongPassword: !this.passwordRegExp.test(e.target.value)
      })
    } else {
      this.setState({
        wrongPassword: false
      })
    }

    this.props.dispatch(ConfirmActions.updatePassword(e.target.value));
  }

  protected updateConfirmPassword(e) {
    this.props.dispatch(ConfirmActions.updateConfirmPassword(e.target.value));
  }

  protected signin() {
    this.props.dispatch(ConfirmActions.signinRequest(this.state.signinUserId, this.props.confirm.password, this.state.signinUserAgencyId, this.props.confirm.user.email || this.state.email));
  }

  protected signout() {
    this.props.dispatch(SignoutActions.request());
  }

  protected confirmAccount() {
    this.props.dispatch(
      ConfirmActions.confirmAccountRequest(
        this.props.confirm.password,
        this.props.confirm.confirmPassword,
        this.props.location?.query?.token,
        "confirmAccount"
      )
    );
  }

  protected resetPassword() {
    this.props.dispatch(
      ConfirmActions.resetPasswordRequest(
        this.props.confirm.password,
        this.props.confirm.confirmPassword,
        this.props.location?.query?.token
      )
    );
  }

  protected resendConfirmationMail() {
    if (this.state.id !== null) {
      this.props.dispatch(ConfirmActions.resendConfirmationMailRequest(this.state.id));
    } else {
      this.props.dispatch(ConfirmActions.resendConfirmationMailRequest(this.props.app.session.user));
    }
  }

  protected closePopup() {
    this.props.dispatch(ConfirmActions.closePopupStart());
  }

  protected renderResendToken() {
    return (
      <div className="state-auth">
        <div className="box component-confirm action-confirm">

          <div className="image-container">
            {this.image.getAvatar("info", { size: 62 })}
          </div>

          <h2>{this.trans("title-confirmation-link-expired")}</h2>

          <p>{this.trans("title-confirmation-link-expired-footer", { email: this.state.email } )}</p>

          <Button
            variant="contained"
            color="primary"
            fullWidth={true}
            onClick={this.resendConfirmationMail.bind(this)}
            style={{ margin: "20px 0" }}
          >
            {this.trans("button-send-confirmation-mail")}
          </Button>

          <Link to="/auth/check-email">
            {this.trans("link-back-to-signin")}
          </Link>

          <PromptDialog
            {...this.props}
            content={this.props.confirm.popupMessage}
            openLeavePrompt={this.props.confirm.popup === true}
            onlyPositiveButton={true}
            prioritizeClosing={true}
            withoutDefaultDilaogButtons={false}
            actions={[
              <Button
                variant="contained"
                color="primary"
                onClick={this.closePopup}
              >
                {this.trans("button-close")}
              </Button>
            ]}
            hideCross={true}
          />
        </div>
      </div>
    );
  }

  protected renderInitialConfirmPage() {
    return (
      <div className="state-auth">
        <div className="box component-confirm action-confirm">

          <div className="image-container">
            {this.image.getAvatar("info", { size: 62 })}
          </div>

          <h2>{this.trans("title-account-not-confirmed-header")}</h2>

          <p>{this.trans("title-account-not-confirmed-footer", { email: this.props.app.session.user.email } )}</p>

          <Button
            variant="contained"
            color="primary"
            fullWidth={true}
            onClick={this.resendConfirmationMail.bind(this)}
            style={{ margin: "20px 0" }}
          >
            {this.trans("button-send-confirmation-mail")}
          </Button>

          <Link to="/auth/check-email">
            {this.trans("link-back-to-signin")}
          </Link>

          <PromptDialog
            {...this.props}
            content={this.props.confirm.popupMessage}
            openLeavePrompt={this.props.confirm.popup === true}
            onlyPositiveButton={true}
            prioritizeClosing={true}
            withoutDefaultDilaogButtons={false}
            actions={[
              <Button
                variant="contained"
                color="primary"
                onClick={this.closePopup}
              >
                {this.trans("button-close")}
              </Button>
            ]}
            hideCross={true}
          />
        </div>
      </div>
    );
  }

  protected renderEnterPasswordForm() {
      return (
        <div className="state-auth">
          <div className="box component-confirm action-enter">

          <div style={{textAlign: "center"}}>
            <h1>Casadesk</h1>

            {!this.state.tokenAlreadyUsed && (
              <React.Fragment>
                <div className="main-text-of-step" style={{margin: "5px 0 -10px 0"}}>
                  {this.trans("confirmnewpassword/main-text")}
                </div>
                
                <div className="info-text-gray">
                  {this.trans("confirmnewpassword/info-text")}
                </div>
              </React.Fragment>
            )}
          </div>

          <form>
            {
              this.state.tokenAlreadyUsed ?
              <p className="error-element">{this.trans("be_token_already_used")}</p>              
              :
              <div>
                <input type="password" style={{display: "none"}} />

                <TextField
                  autoComplete="off"
                  className="form-element"
                  autoFocus={true}
                  label={this.trans("label-password")}
                  type="password"
                  fullWidth={true}
                  value={this.props.confirm.password}
                  onChange={this.updatePassword}
                  onKeyPress={(e) => {(e.key ==="Enter" ? this.confirmAccount() : null)}}
                  variant="standard"
                  error={!!this.props.confirm.popupMessage}
                  helperText={this.props.confirm.popupMessage}
                />
                
                <div 
                  className="component-error-text"
                  style={{
                    color: !this.props.confirm.password || (this.props.confirm.password && this.state.wrongPassword) ? "gray" : "green"
                  }}
                >
                  <div>{this.trans("be_password_regex_invalid")}</div>
                  <div>{this.trans("be_password_regex_invalid-1")}</div>
                </div>

                <TextField
                  autoComplete="off"
                  className="form-element"
                  label={this.trans("label-confirm-password")}
                  type="password"
                  fullWidth={true}
                  value={this.props.confirm.confirmPassword}
                  onChange={this.updateConfirmPassword}
                  onKeyPress={(e) => {(e.key ==="Enter" ? this.confirmAccount() : null)}}
                  variant="standard"
                  error={!!this.props.confirm.popupMessage}
                  helperText={this.props.confirm.popupMessage}
                />

                <Button
                  variant="contained"
                  color="primary"
                  fullWidth={true}
                  onClick={this.confirmAccount.bind(this)}
                  disabled={this.props.confirm.isFetching}
                  style={{ margin: "20px 0" }}
                >
                  {this.props.confirm.isFetching === true ? this.trans("button-saving") : this.trans("button-save")}
                </Button>
              </div>
            }
          </form>
        </div>
      </div>
    );
  }

  protected renderResetPasswordForm() {
    return (
      <div className="state-auth">
        <div className="box component-confirm action-reset">
          <div style={{textAlign: "center"}}>
            <h1>Casadesk</h1>

            <div className="main-text-of-step" style={{margin: "5px 0 -10px 0"}}>
              {this.trans("resetconfirmnewpassword/main-text")}
            </div>
            
            <div className="info-text-gray">
              {this.trans("resetconfirmnewpassword/info-text")}
            </div>
          </div>

          <form>
            <TextField
              autoComplete="off"
              className="form-element"
              autoFocus={true}
              label={this.trans("label-password")}
              type="password"
              fullWidth={true}
              value={this.props.confirm.password}
              onChange={this.updatePassword}
              onKeyPress={(e) => {(e.key === "Enter" ? this.resetPassword() : null)}}
              variant="standard"
              error={!!this.props.confirm.popupMessage || this.state.wrongPassword}
            />
            {!!this.props.confirm.popupMessage && <div className="component-error-text">{this.props.confirm.popupMessage}</div>}
            {!this.props.confirm.popupMessage && !!this.state.wrongPassword && <div className="component-error-text"><div>{this.trans("be_password_regex_invalid")}</div><div>{this.trans("be_password_regex_invalid-1")}</div></div>}

            <TextField
              autoComplete="off"
              className="form-element"
              label={this.trans("label-confirm-password")}
              type="password"
              fullWidth={true}
              value={this.props.confirm.confirmPassword}
              onChange={this.updateConfirmPassword}
              onKeyPress={(e) => {(e.key === "Enter" ? this.resetPassword() : null)}}
              variant="standard"
              error={this.props.confirm.translatedMessage === "" ? !!this.props.confirm.popupMessage : !!""}
            />
            {!!this.props.confirm.popupMessage && <div className="component-error-text">{this.props.confirm.popupMessage}</div>}

            <Button
              variant="contained"
              color="primary"
              fullWidth={true}
              onClick={this.resetPassword.bind(this)}
              disabled={this.props.confirm.isFetching}
              style={{ margin: "20px 0" }}
            >
              {this.props.confirm.isFetching === true ? this.trans("button-saving") : this.trans("button-save")}
            </Button>
          </form>
        </div>
      </div>
    );
  }

  public changeAgency = (event) => {
    const agencyId = event.target.value;
    const user = this.props.confirm.users.find(user => user.agencyId === agencyId);
    const sessionUser: PersonInterface = PersonFactory.create(user);
    const sessionUserSettings: UserSettingsInterface = UserSettingsFactory.create(user.userSettings[0]);
    this.props.dispatch(UserActions.auth(sessionUser, sessionUserSettings));

    this.setState({
      signinUserFirstName: user && user.firstName ? user.firstName : "",
      signinUserLastName: user && user.lastName ? user.lastName : "",
      signinUserAgencyId: agencyId,
      signinUserId: user && user.id
    });
  }

  protected renderSigninForm() {
    // const selectedAgency = this.props.confirm.agencies.find(agency => agency.id === this.state.signinUserAgencyId);
    // const avatar = selectedAgency?.attachments?.find(attachment => attachment.isAvatar);

    return (
      <div className="state-auth">
        <div className="box component-confirm action-signin">

          <h1>Casadesk</h1>

          <p>{this.props.confirm.user.email}</p>

          <form onSubmit={e => e.preventDefault()}>
            <TextField
              className="form-element"
              type="email"
              autoComplete="email"
              autoFocus={true}
              fullWidth={true}
              label={this.trans("label-email")}
              value={this.props.confirm.user.email}
              style={{display: "none"}}
              variant="standard"
              error={false}
            />

            <Select
              className="form-element full-size form-input scroll-to-agency correct-label-position"
              error={this.getErrorFor("agency")}
              value={this.state.signinUserAgencyId}
              onChange={this.changeAgency}
              htmlFor="agency"
              name="agency"
              id="agency"
              label={this.trans("label-agency")}
            >
              {this.props.confirm.agencies.map(agency => {
                return (
                  <MenuItem key={`${agency.name}-${agency.id}`} value={agency.id}>{agency.name}</MenuItem>
                );
              })}
            </Select>

            <TextField
              autoFocus={true}
              className="form-element"
              label={this.trans("label-password")}
              type="password"
              autoComplete="password"
              fullWidth={true}
              value={this.props.confirm.password}
              onChange={this.updatePassword}
              onKeyPress={e => e.key === "Enter" ? this.signin() : null}
              variant="standard"
              error={!!this.props.confirm.popupMessage}
            />
            {!!this.props.confirm.popupMessage && <div className="component-error-text">{this.props.confirm.popupMessage}</div>}

            <Button
              variant="contained"
              color="primary"
              fullWidth={true}
              onClick={this.signin.bind(this)}
              disabled={this.props.confirm.isFetching}
              style={{ margin: "20px 0" }}
            >
              {this.props.confirm.isFetching === true ? this.trans("button-please-wait") : this.trans("label-signin")}
            </Button>

            <div>
              <Link to="/auth/check-email">{this.trans("link-back-to-signin")}</Link>
              <Link to="/auth/forgot-password">{this.trans("link-forgot-password")}?</Link>
            </div>

          </form>
        </div>
      </div>
    );
  }

  public render() {
    switch (this.state.type) {
      case this.types.standard:
        return this.props.app.session.user.contactStatusId === 1 ?
        this.renderSigninForm() : this.renderInitialConfirmPage();

      case this.types.confirm:
        return this.renderEnterPasswordForm();

      case this.types.reset:
        return this.renderResetPasswordForm();
      case this.types.expired:
        return this.renderResendToken();

      default:
        return;
    }
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    confirm: state.confirm,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Confirm
);
